import formatNumber from '../commonFunctions/formatNumber';

const numberValue = () => {
    const numberValuesElememnts = document.querySelectorAll('.Number-value');

    if (numberValuesElememnts) {
        numberValuesElememnts.forEach((el) => {
            const thisElement = el;
            const elValue = el.textContent;
            thisElement.innerHTML = formatNumber(elValue);
        });
    }
};

export default numberValue;
